<template>
  <div class="animated fadeIn">

    <b-row class="mt-2">
      <b-col class="d-flex">
        <b-card class="w-100">
          <h2>Classified Listings</h2>
          <div class="lead">Listings are the core of AdReplay. Create your advertisement posts and adjust posting schedules here to spread your word across the internet!</div>
        </b-card>
      </b-col>
      <b-col :lg="4" class="d-flex">
        <b-card class="w-100 clickable" body-class="d-flex flex-grow-1 flex-column justify-content-center text-center" @click="$router.push('/listings/new')">
          <div>
              <i class="icon-plus font-3xl text-primary d-block mt-3"></i>
              <h4 class="mt-3">Create New Listing</h4>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-card v-loading="loading">
      <h4>My Listings</h4>
      <b-table v-if="listings.length > 0" striped hover :items="listings" :fields="fields" class="mt-4 mb-0">
        <template slot="title" slot-scope="data">
          <b-link :to="`/listings/${data.item.id}`" style="font-size: 1rem;">{{data.item.title}}</b-link>
        </template>
        <template slot="active" slot-scope="data">
          <b-badge v-if="data.item.schedule.days === null || Object.keys(data.item.schedule.days).length === 0" variant="warning" class="py-1 px-2" v-b-tooltip.hover title="This listing has no schedule setup so it cannot be posted">PENDING</b-badge>
          <b-badge v-else :variant="data.item.active ? 'success' : 'danger'" class="py-1 px-2">{{data.item.active ? 'ACTIVE' : 'PAUSED'}}</b-badge>
        </template>
        <template slot="kijiji" slot-scope="data">
          <i v-if="data.item.kijiji.active" class="active-icon text-success cui-circle-check"></i>
          <i v-else class="active-icon text-danger cui-circle-x"></i>
        </template>
        <template slot="nextPost" slot-scope="data">
          <span v-b-tooltip.hover title="The listing is posted at a random minute within this hour">{{nextPost(data.item)}}</span>
        </template>
        <template slot="craigslist" slot-scope="data">
          <i v-if="data.item.craigslist.active" class="active-icon text-success cui-circle-check"></i>
          <i v-else class="active-icon text-danger cui-circle-x"></i>
        </template>
        <template slot="actions" slot-scope="data">
          <b-button-group>
            <b-button variant="outline-primary" size="sm" :to="`/listings/${data.item.id}`">Stats</b-button>
            <b-button variant="primary" size="sm" :to="`/listings/${data.item.id}/edit`">Edit</b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-alert :show="listings.length === 0" variant="info" class="mt-4 mb-0 py-3 px-3 d-flex align-items-center">
        <i class="icon-info mr-2"></i>
        <div>You have no classified listings. <b-link to="/listings/new">Create one?</b-link></div>
      </b-alert>
    </b-card>
  </div>
</template>

<script>
import EventBus from "../../shared/event-bus";
import moment from 'moment'

const fields = {
  'title': {
    label: 'Title',
    sortable: true,
  },
  'nextPost': {
    label: 'Next Post',
    class: 'text-center',
    sortable: true,
    thStyle: { width: '150px' }
  },
  'kijiji': {
    label: 'Kijiji',
    class: 'text-center',
    sortable: true,
    thStyle: { width: '100px' }
  },
  // 'craigslist': {
  //   label: 'Craigslist',
  //   class: 'text-center',
  //   sortable: true,
  //   thStyle: { width: '120px' }
  // },
  'active': {
    label: 'Active',
    class: 'text-center',
    sortable: true,
    thStyle: { width: '150px' }
  },
  'actions': {
    label: 'Actions',
    class: 'text-center',
    thStyle: { width: '140px' }
  }
}

export default {
  name: 'ListingsIndex',

  data(){
    return {
      fields,
      listings : [],

      // State
      loading : true,
      error   : ''
    }
  },

  mounted(){
    this.load()
  },


  beforeDestroy(){
    if( this._message ){
      EventBus.$emit('messages.hide', this._message)
    }
  },

  watch: {
    listings(){
      this.hasMissingSchedule()
    }
  },

  methods: {
    load(){
      this.loading = true
      this.$API.v2.Listings.List()
      .then((listings) => {
        this.listings = listings
      })
      .catch((err) => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
    },

    hasMissingSchedule(){
      const hasMissingSchedule = this.listings.reduce((acc, item) => {
        if( item.schedule.days === null || Object.keys(item.schedule.days).length === 0 ){
          acc = true
        }

        return acc
      }, false)

      if( hasMissingSchedule ){
        if( this._message ){
          EventBus.$emit('messages.hide', this._message)
        }
        EventBus.$emit('messages.show', ['One or more listings on this page have no schedule setup and <strong>cannot be posted</strong>. To correct this, please edit each pending listing and add a schedule to it.', 'warning', false], ({ id }) => {
          this._message = id
        })
      }
      else {
        if( this._message ){
          EventBus.$emit('messages.hide', this._message)
        }
      }
    },

    nextPost(listing){
      var schedule = listing.schedule.days || {}
      let nextPost = Object.keys(schedule).reduce((acc, day) => {
          let hours = schedule[day] || []
          hours.forEach((hour) => {
              const m = moment()
              m.day(day)
              m.hour(hour)
              m.minute(59)
              m.second(59)

              if( !acc && m.isAfter() ){
                  acc = m
              }
          })

          return acc
      }, false)

      if( !nextPost ){
        return "never"
      }

      return nextPost.format('MMM D, YYYY h:00a')
    }
  }
};
</script>

<style lang="scss" scoped>
.lh-2 {
  line-height: 1.5rem;
}

.fw-400 {
  font-weight: 400;
}

.active-icon {
  font-size: 24px;
}
</style>
